<template>
	<div class="ui modal" ref="modal">
		<div class="header">Hvala za nakup interaktivnih gradiv iRokus.</div>
		<div class="content">
			<template v-if="data.personal">
				Predračun boste prejeli na svoj e-naslov.
			</template>
			<template v-else>
				Izbrana gradiva so dodana v vašo iZbirko. Račun bomo poslali na vašo šolo.
			</template>
		</div>
		<div class="actions">
			<div class="ui yellow button approve" v-on:click="close">V iZbirko</div>
		</div>
	</div>
</template>

<script>
	import popup from './Popup.vue'

    export default {
    	mixins: [popup],
    	props: ['data'],
    	methods: {
    		close() {
        		window.location.href = this.route('izbirka');
        	}
    	}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/modals/PurchaseSuccess.vue